export function delimiterItemTelValidator(value: any, params: any[] | Record<string, any>) {
  const items = value.split(/\r\n|\n/)
  for (const item of items) {
    const trimmed = item.trim()

    if (trimmed.length === 0) {
      continue
    }

    // 電話番号は半角数字のみ許容
    if (!/^[0-9]+$/.test(trimmed)) {
      return false
    }
  }

  return true
}
